import React, { FC, useEffect, useState } from "react";
import NewsVideoPlayer from "newComponents/Shared/WhatNew/NewsVideoPlayer/NewsVideoPlayer";
import Icon from "newComponents/Shared/_Atoms/Icons/Icon/Icon";
import { useSelector } from "react-redux";
import FullscreenImage from "./FullscreenImage/FullscreenImage";
import NEWS from "constants/localization/news";
import { makeSelectCurrentUser } from "Store/user/selectors";
import { getSlidesToDisplay } from "utils/newsHelpers";
import colors from "constants/colors";

interface IProps {
  fromModal?: boolean;
  style?: React.CSSProperties;
}

const WhatsNew: FC<IProps> = ({ fromModal, style }) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [fullscreenImage, setFullscreenImage] = useState(null);
  const [news, setNews] = useState<News[]>(NEWS);
  const activeUser = useSelector(makeSelectCurrentUser);

  const handleFullscreenImage = (image: string) => {
    setFullscreenImage(image);
  };

  const getMediaElement = (item) => {
    const env = process.env.BUILD;
    if (item.hasOwnProperty("video")) {
      return <NewsVideoPlayer videoUrl={item.video} />;
    } else if (item.hasOwnProperty("image")) {
      return (
        <img
          src={`${env !== "dev" ? "/admin" : ""}/static/images/${item.image}`}
          alt={item.title}
          onClick={() => handleFullscreenImage(item.image)}
        />
      );
    }
  };

  const prevSlide = () => {
    setActiveSlide(activeSlide === 0 ? news.length - 1 : activeSlide - 1);
  };
  const nextSlide = () => {
    setActiveSlide(activeSlide + 1 === news.length ? 0 : activeSlide + 1);
  };

  useEffect(() => {
    if (activeUser && activeUser.last_version_seen && fromModal) {
      setNews(getSlidesToDisplay(activeUser?.last_version_seen));
    }
  }, [activeUser]);

  return (
    <div className="carousel-container" style={style}>
      <div className="slide-title">
        {news && news.length > 0 && news[activeSlide] && news[activeSlide].title}
      </div>
      <div className="slides-container">
        {activeSlide !== 0 && (
          <div className="slides-left-arrow" onClick={prevSlide}>
            <Icon icon="chevron-left" color={colors.black} />
          </div>
        )}
        <div className="slides">
          {news?.length > 0
            ? news.map((item, index) => (
                <div className={`slide ${index === activeSlide ? "active" : ""}`} key={index}>
                  {index === activeSlide && (
                    <>
                      <div className="slide-media">{getMediaElement(item)}</div>
                      {item.description && (
                        <div
                          className="slide-description"
                          dangerouslySetInnerHTML={{ __html: item.description }}
                        />
                      )}
                    </>
                  )}
                </div>
              ))
            : null}
        </div>
        {activeSlide + 1 !== news.length && (
          <div className="slides-right-arrow" onClick={nextSlide}>
            <Icon icon="chevron-right" color={colors.black} />
          </div>
        )}
      </div>
      <div className="carousel-dots">
        {news.map((item, index) => (
          <span key={index} className={`carousel-dot ${activeSlide === index ? "active" : ""}`} />
        ))}
      </div>
      {fullscreenImage && (
        <FullscreenImage image={fullscreenImage} onClose={() => setFullscreenImage(null)} />
      )}
    </div>
  );
};

export default WhatsNew;
